import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getGroupInvoiceAdHocFees = info =>
  call(websocketFetch, 'get_group_invoice_ad_hoc_fees', info);
